import Link from 'next/link'
import Button from '@/src/components/core/Button'
import WhatsappIcon from '@/src/components/core/icons/WhatsappIcon'

export default function WhatsappButton({
  message = 'Liebes BLINK Team, ',
  number = '41315391065',
}: {
  message?: string
  number?: string
}) {
  const link = `https://wa.me/${number}?text=${encodeURIComponent(message)}`

  return (
    <Button
      as={Link}
      href={link}
      target="_blank"
      version="green"
      icon={<WhatsappIcon />}
      rel="noopener noreferrer"
      size="icon-small"
      aria-label="Kontakt Whatsapp"
    />
  )
}
